import { fetchBlogs } from "../../services/blogsService";
import { AdminFeatures } from "../AdminFeatures/Features";

export async function fetchByFeature(feature){
  if(feature === AdminFeatures.BLOG_MANAGEMENT){
      console.log("tableList : ",1);

      const list = await fetchBlogs();
      console.log("tableList : ",list);
      return list;
  }
}